import script from "./[plan].vue?vue&type=script&setup=true&lang=ts"
export * from "./[plan].vue?vue&type=script&setup=true&lang=ts"

import "./[plan].vue?vue&type=style&index=0&id=34b7c072&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b7c072"]])

export default __exports__